Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryAvatarView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_avatar']
  className: 'summary-avatar'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary

  render: ->
    @$el.html @template
      avatar: @_avatar()
      defaultAvatar: @_defaultAvatar()
      subTypeIcons: @_subTypeIcons()
    @

  _avatar: ->
    @ticketSummary.get('author_avatar') || @_defaultAvatar()

  _defaultAvatar: ->
    avatar = window.default_avatar_for(@ticketSummary.get('sub_type'))

  _subTypeIcons: ->
    iconPath = window.icon_for @ticketSummary.get('sub_type')
    return null unless iconPath
    {
      regular: window.image_path(iconPath + '.png')
      twoX: window.image_path(iconPath + '@2x.png')
      threeX: window.image_path(iconPath + '@3x.png')
    }
